<template>
  <div>
    <apexchart
      :type="type"
      :height="height"
      :options="chartOptions"
      :series="data"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
export default {
  name: "apexChart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    type: {
      default: "bar",
    },
    height: {
      default: 300,
    },
    chartOptions: {
      default: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            borderRadiusApplication: "last",
          },
        },
        xaxis: {
          categories: [],
        },
      },
    },
    data: {
      default: [
        {
          name: "Gösterim",
          data: [
            {
              x: "2011",
              y: 12,
              fillColor: "#ff0000",
              goals: [
                {
                  name: "Sınır",
                  value: 14,
                  strokeColor: "#775DD0",
                },
              ],
            },
            {
              x: "2012",
              y: 12,
              fillColor: "#ff0000",
              goals: [
                {
                  name: "Sınır",
                  value: 14,
                  strokeColor: "#775DD0",
                },
              ],
            },
          ],
        },
      ],
    },
  },
  data: function() {
    return {
      series: [
        {
          name: "Doluluk",
          data: [
            {
              x: "2011",
              y: 12,
              fillColor: "#ff0000",
              goals: [
                {
                  name: "Sınır",
                  value: 14,
                  strokeColor: "#775DD0",
                },
              ],
            },
          ],
        },
      ],
    };
  },
};
</script>

<style></style>
